var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 27.5588C30.5 31.5398 24.7929 32 20.5013 32L20.1941 31.9997C17.4599 31.9934 10.5 31.8283 10.5 27.5347C10.5 23.6349 15.9777 23.1137 20.2367 23.0941L20.8084 23.0937C23.5425 23.1001 30.5 23.2652 30.5 27.5588ZM20.5013 24.9052C15.1212 24.9052 12.3939 25.7894 12.3939 27.5347C12.3939 29.2957 15.1212 30.1883 20.5013 30.1883C25.8801 30.1883 28.6061 29.3041 28.6061 27.5588C28.6061 25.7978 25.8801 24.9052 20.5013 24.9052ZM20.5013 8C24.1982 8 27.2045 10.877 27.2045 14.4136C27.2045 17.9501 24.1982 20.8259 20.5013 20.8259H20.4609C16.7715 20.815 13.7828 17.9368 13.7954 14.4099C13.7954 10.877 16.803 8 20.5013 8ZM20.5013 9.72478C17.798 9.72478 15.5985 11.8276 15.5985 14.4136C15.5896 16.9911 17.7727 19.0927 20.4646 19.1023L20.5013 19.9647V19.1023C23.2033 19.1023 25.4015 16.9983 25.4015 14.4136C25.4015 11.8276 23.2033 9.72478 20.5013 9.72478Z",
    fill: "#9142C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUserIcon);
export default __webpack_public_path__ + "static/media/total-user-icon.b5ed9f8ebc92d3d2d66c290d5536d5a4.svg";
export { ForwardRef as ReactComponent };